export function isUUID(uuid?: string) {
  if (!uuid) {
    return false;
  }

  return new RegExp(
    '^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$',
  ).test(uuid);
}
